<script setup lang="ts">
/**
 * The terms of the ADAC feature, as Apodis's lawyer wrote them.
 *
 * Word for word: this is what the pharmacist accepts, and the PDF of the
 * `adac` contract's current version must carry the very same text — a change
 * here is a new contract version, which every pharmacy accepts anew.
 */
</script>

<template>
  <div class="space-y-3 text-sm text-gray-600">
    <h3 class="font-bold text-primary">
      Activation du service d’aide à la détection d’atypies de consommation – ADAC
    </h3>
    <p>
      Le service ADAC de l’Assurance Maladie permet au pharmacien de consulter, dans le cadre de la
      prise en charge d’un patient, des informations utiles à la détection d’éventuelles atypies de
      consommation de certains médicaments ou dispositifs médicaux.
    </p>
    <p>
      Afin de faciliter l’utilisation de ce service au comptoir, Apodis met à votre disposition une
      fonctionnalité permettant de simplifier l’accès à ADAC et de restituer le résultat directement
      dans votre environnement de travail.
    </p>
    <p>
      La consultation d’ADAC reste réalisée à votre initiative, sous votre identité professionnelle et
      sous votre responsabilité de pharmacien.
    </p>

    <h4 class="font-bold text-gray-dark">
      Authentification sécurisée
    </h4>
    <p>
      L’authentification auprès des services de l’Assurance Maladie repose sur votre CPS/e-CPS et les
      dispositifs d’authentification associés.
    </p>
    <p>
      Votre code confidentiel CPS/e-CPS reste strictement personnel. Il n’est jamais connu, lu,
      collecté, transmis ni conservé par Apodis.
    </p>
    <p>
      Apodis intervient uniquement pour faciliter techniquement l’accès au service après votre
      authentification.
    </p>

    <h4 class="font-bold text-gray-dark">
      Traitement des informations
    </h4>
    <p>
      Dans le cadre de cette fonctionnalité, Apodis agit en qualité de prestataire technique et,
      lorsque cela est applicable, de sous-traitant de l’officine.
    </p>
    <p>
      Apodis traite uniquement les informations strictement nécessaires à l’interrogation du service
      ADAC et à la restitution du résultat dans son interface.
    </p>
    <p>
      Les informations issues d’ADAC ne sont pas utilisées par Apodis à d’autres finalités et ne font
      l’objet d’aucune exploitation commerciale ou utilisation secondaire.
    </p>
    <p>
      Les données issues d’ADAC ne font pas l’objet d’une conservation persistante par Apodis
      au-delà de ce qui est strictement nécessaire au fonctionnement du service.
    </p>

    <h4 class="font-bold text-gray-dark">
      Information du patient
    </h4>
    <p>
      Vous vous engagez à utiliser cette fonctionnalité uniquement dans le cadre de votre exercice
      professionnel et de la prise en charge des patients de votre officine.
    </p>
    <p>
      Avant toute consultation ADAC, le patient, ou son représentant légal lorsque cela est
      applicable, doit être informé de la consultation de ses informations de délivrance et de
      remboursement conformément aux règles applicables au service ADAC.
    </p>

    <h4 class="font-bold text-gray-dark">
      Autorisation donnée à Apodis
    </h4>
    <p>En activant cette fonctionnalité, vous :</p>
    <ul class="list-disc space-y-1 pl-5">
      <li>reconnaissez avoir pris connaissance de son fonctionnement ;</li>
      <li>
        autorisez Apodis à réaliser, pour votre compte et sur vos instructions, les seules opérations
        techniques nécessaires à l’accès au service ADAC et à la restitution du résultat dans
        l’interface Apodis ;
      </li>
      <li>reconnaissez que votre authentification CPS/e-CPS reste personnelle et sous votre contrôle ;</li>
      <li>reconnaissez qu’Apodis n’a jamais accès à votre code confidentiel CPS/e-CPS ;</li>
      <li>
        vous engagez à utiliser cette fonctionnalité uniquement dans le cadre de votre exercice
        professionnel et conformément aux conditions d’utilisation du service ADAC.
      </li>
    </ul>
  </div>
</template>
